import { useCallback, useState } from 'react';

/**
 * Blurred + empty: render {@link placeholder} as the input value (full opacity).
 * Focused + empty: empty value with faded native placeholder.
 */
export const useReportEditableFieldDisplay = (
  value: string,
  placeholder?: string,
) => {
  const [focused, setFocused] = useState(false);
  const isEmpty = !value.trim();
  const displayValue = !focused && isEmpty && placeholder ? placeholder : value;
  const activePlaceholder = focused && isEmpty ? placeholder : undefined;

  const bindFocusHandlers = useCallback(
    (onBlur?: () => void) => ({
      onFocus: () => setFocused(true),
      onBlur: () => {
        setFocused(false);
        onBlur?.();
      },
    }),
    [],
  );

  return { displayValue, activePlaceholder, bindFocusHandlers };
};
